
import Vue from "vue";
import { Purchase } from "@/models/base";
import { printHumanFloat } from "@/utils/pretty-print";
import {CurrencyService} from "@/services/currency-service";
import Currency from "@/models/base/currency";
import { roundPriceValues } from "@/utils/numbers";
import AppLedgerAccountAutocomlete from "@/components/common/LedgerAccountAutocomplete.vue";
import {BankService, DossierConfigService} from "@/services";
import { PurchaseVatRegime } from "@/services/vat-service";

export default Vue.extend({
	data(){
		return {
			subtractablePercent: this.value.getSubtractablePercent(),
			config: DossierConfigService.getBookkeepingConfig(),
			toggleLedger82B: false
		};
	},
	props: {
		value: {
			type: Object as () => Purchase,
			required: true
		}
	},
	computed: {
		totalBooked():string{
			return printHumanFloat(this.value.getTotalBooked());
		},
		currencyRate(): number {
			let currencies = CurrencyService.getCurrencies();
			if (currencies.length == 0){
				return 1;
			}
			let foundCurrency = currencies.filter((c:Currency) => c.ID == this.value.CurrencyID)[0];
			if (!foundCurrency) return 1;
			return foundCurrency.Rate || 1;
		},
		labelNotSubstracted():string{
			return this.$ct("not-subtractable").toString() + this.$ct("not-subtractable-label",{
				ledger: (this.value.Ledger82B ? this.value.Ledger82B : this.config.VATNotSubtractable)
			}).toString();
		},
	},
	watch: {
		"value.VATAmountCoContracts": {
			immediate: false,
			handler(){
				this.updateVatCoContracts();
			}
		},
		"value.VATAmountImportWithinTheEG": {
			immediate: false,
			handler(){
				this.updateVatImportWithinTheEG();
			}
		},
		"value.VATAmountServicesWithingTheEG": {
			immediate: false,
			handler(){
				this.updateVatImportWithinTheEG();
			}
		},
		"value.Total": {
			immediate: true,
			handler(){
				this.subtractablePercent = this.value.getSubtractablePercent();
			}
		},
		"value.VATServicesAndCosts": {
			immediate: false,
			handler(){
				this.updateVatSubtractable();
			}
		},
		"value.Contact"(){
			this.subtractablePercent = this.value.getSubtractablePercent();
		}
	},
	methods: {
		updateVatImportWithinTheEG(){
			if (this.value.isInternationalVatRegime() && this.value.IsCreditNote){
				this.value.VATImportWithinTheEG = 0;
				return;
			}
			this.value.VATImportWithinTheEG = roundPriceValues((this.value.VATAmountImportWithinTheEG + this.value.VATAmountServicesWithingTheEG) * this.value.getVat());
		},
		updateVatCoContracts(){
			if (this.value.IsCreditNote && this.value.isInternationalVatRegime()){
				this.value.VATCoContracts = 0;
				return;
			}
			if (this.value.Contact && this.value.Contact.VatRegime == PurchaseVatRegime.AANKOOP_BUITEN_DE_EG) return;
			this.value.VATCoContracts = roundPriceValues(this.value.VATAmountCoContracts * this.value.getVat());
		},
		updateVatSubtractable(){
			if (this.value.Contact && this.value.Contact.VatRegime == PurchaseVatRegime.NORMALE_BTW) {
				let total = this.value.getTotalVat();
				this.value.VATSubtractable = roundPriceValues((this.subtractablePercent / 100) * total);
				this.value.VATNotSubtractable = roundPriceValues(total - this.value.VATSubtractable);
			}
		},
		onSubtractablePercentChanged() {
			let total = this.value.getTotalVat();
			this.value.VATSubtractable = roundPriceValues((this.subtractablePercent / 100) * total);
			this.value.VATNotSubtractable = roundPriceValues(total - this.value.VATSubtractable);
			this.subtractablePercent = this.value.getSubtractablePercent();
		},
		onVatSubtractableChanged(){
			let total = this.value.getTotalVat();
			this.value.VATNotSubtractable = roundPriceValues(total - this.value.VATSubtractable);
			this.subtractablePercent = this.value.getSubtractablePercent();
		},
		onVatNotSubtractableChanged(){
			let total = this.value.getTotalVat();
			this.value.VATSubtractable = roundPriceValues(total - this.value.VATNotSubtractable);
			this.subtractablePercent = this.value.getSubtractablePercent();
		},
		setLedger82B(val:string){
			this.value.Ledger82B = val;
			let types = BankService.getTypes();
			for (let b of types){
				if (b.LedgerNumber != val) continue;
				let text = this.$ct("warning-ledger-is-used-for-bank-type", {typeName: b.Name});
				this.$wf.dialog(text, this.$ct("common.ok"), this.$ct("common.warning"), "warning");
				break;
			}
		}
	},
	created() {
		if(this.value.ID == 0 && this.config.VATNotSubtractable != "640000"){
			this.setLedger82B(this.config.VATNotSubtractable);
		}
	},
	components: {
		AppLedgerAccountAutocomlete
	},
	i18nEx: {
		componentPrefix: "components.purchases"
	}
});
